import { ConfigProvider } from "antd";
import viVN from "antd/es/locale/vi_VN";
import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import LogRocket from "logrocket";
import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import store from "../src/redux/store";
import App from "./App";
import "./index.css";
import i18n from "./locales/i18n";
import { AuthProvider } from "context/AuthContext";
import { authZitadelConfig } from "config/auth";

flagsmith
  .init({
    api: process.env.REACT_APP_FLAGSMITH_URL,
    environmentID: process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_ID,
    cacheFlags: true,
  })
  .then(() => {
    flagsmith.startListening(60000);
  });
if (process.env.REACT_APP_ENV === "production") {
  LogRocket.init("ednwuf/honganh-ops");
}
ReactDOM.render(
  <React.StrictMode>
    <AuthProvider config={authZitadelConfig}>
      <FlagsmithProvider flagsmith={flagsmith}>
        <I18nextProvider i18n={i18n}>
          <ConfigProvider locale={viVN}>
            <Provider store={store}>
              <App />
            </Provider>
          </ConfigProvider>
        </I18nextProvider>
      </FlagsmithProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
